import PopUp from '@/common/components/PopUp';
import Loading from '@/common/components/Loading';
import { useMakeMailTemplateCopy } from './hooks/useMakeMailTemplateCopy';
import SelectInput from '@/common/components/SelectInput';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { ButtonContainer, Splitter } from './MailTemplateCopy.styles';

const MailTemplateCopy = ({ setCopy, copy }) => {
	const {
		handleCopyTemplates,
		isLoading,
		selectedLanguages,
		setSelectedLanguages,
		nativeLanguageOptions,
	} = useMakeMailTemplateCopy({ setCopy, copy });

	return (
		<>
			{isLoading && <Loading />}
			<PopUp setShow={setCopy}>
				<h3>Copy Template: {copy.name}</h3>
				<SelectInput
					name={'Pick Languages to Copy'}
					options={nativeLanguageOptions}
					selected={selectedLanguages}
					setSelected={setSelectedLanguages}
					multiple={true}
				/>
				<Splitter/>
				<ButtonContainer>
					<SubmitButton
						onClick={handleCopyTemplates}
						text={'Start Copy Job'}
					/>
				</ButtonContainer>
			</PopUp>
		</>
	);
};

export default MailTemplateCopy;